import { render, staticRenderFns } from "./cv-data-table-cell.vue?vue&type=template&id=1f3f5374&"
import script from "./cv-data-table-cell.vue?vue&type=script&lang=js&"
export * from "./cv-data-table-cell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports